import { render, staticRenderFns } from "./MandobClientSadadReportPrint.vue?vue&type=template&id=ebec8870&"
import script from "./MandobClientSadadReportPrint.vue?vue&type=script&lang=js&"
export * from "./MandobClientSadadReportPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports